import { setLanguage, supportedLanguages } from '$lib/i18n.js';
import { error } from '@sveltejs/kit';

export const prerender = true;

export async function load({ params }) {
	const { lang } = params;
	
	// Verifica che la lingua sia supportata
	if (!supportedLanguages.includes(lang)) {
		throw error(404, `Language '${lang}' not found`);
	}
	
	// Imposta la lingua corrente
	setLanguage(lang);
	
	return {
		lang
	};
}

